import React, { useContext, createContext, ReactNode, FC } from 'react'
import { useNav } from 'utils/hooks/useNav'

const NavContext = createContext<ReturnType<typeof useNav>>({
  isNavOpen: false,
  isNavExpanded: true,
  setNavOpen: () => {},
  toggleNav: () => {},
  setNavExpanded: () => {},
  toggleExpand: () => {},
})

interface INavProviderProps {
  children: ReactNode
  /**
   * @default false
   */
  initialState?: boolean
  /**
   * @default true
   */
  initialExpanded?: boolean
}

export const NavProvider: FC<INavProviderProps> = ({
  children,
  initialExpanded = true,
  initialState = false,
}) => {
  const state = useNav({ initialState, initialExpanded })
  return <NavContext.Provider value={state}>{children}</NavContext.Provider>
}

export const useNavContext = () => useContext(NavContext)
